import { render } from "./ChangeLayout.vue?vue&type=template&id=278cb3b9&scoped=true&ts=true&lang=pug"
import script from "./ChangeLayout.vue?vue&type=script&lang=ts"
export * from "./ChangeLayout.vue?vue&type=script&lang=ts"

import "./ChangeLayout.vue?vue&type=style&index=0&id=278cb3b9&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278cb3b9"]])

export default __exports__